<template>
  <div>
    <main>
      <div class="wrapper" :style="`width: calc(100vw - ${sideNavWidth}px)`">
        <client
          :class="!hasNameSet && 'name-unset'"
          id="createTemplate"
          :title="title"
          isTemplate
        />
      </div>
    </main>
    <unsavedChangesModal
      :value="showLeaveConfirmation"
      @closeModal="cancelConfirmation"
      @confirmLeave="leave"
    />
    <fullscreenLoader v-if="isLoading" />
  </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import client from "@/components/client";
import fullscreenLoader from "@/qux-common/qux22/components/molecules/fullscreen-loader";
import unsavedChangesModal from "@/components/unsaved-changes-modal";

export default {
  components: {
    client,
    fullscreenLoader,
    unsavedChangesModal,
  },
  data() {
    return {
      showLeaveConfirmation: false,
      deferredRoute: undefined,
    };
  },
  methods: {
    cancelConfirmation() {
      this.showLeaveConfirmation = false;
      this.deferredRoute = undefined;
    },
    leave() {
      this.$router.push(this.deferredRoute);
    },
  },
  computed: {
    isLoading() {
      return this.pendingCalls.includes("/client/list");
    },
    hasNameSet() {
      return (
        !!this.updatedValues.createTemplate &&
        this.updatedValues.createTemplate.Info &&
        this.updatedValues.createTemplate.Info.TemplateName
      );
    },
    title() {
      return (
        (this.updatedValues.createTemplate &&
          this.updatedValues.createTemplate.Info &&
          this.updatedValues.createTemplate.Info.TemplateName) ||
        "Template Name"
      );
    },
    ...mapGetters({
      sideNavWidth: "getSideNavWidth",
      updatedValues: "getUpdatedConfigValues",
      hasUpdatedConfigValues: "hasUpdatedConfigValues",
      pendingCalls: "getPendingCallList",
    }),
  },
  mounted() {
    this.$store.dispatch("fetchExistingIds");
  },
  beforeRouteLeave(to, from, next) {
    if (to.query.action === "savedTemplate") next();
    if (this.hasUpdatedConfigValues.createTemplate && !this.deferredRoute) {
      this.deferredRoute = to;
      this.showLeaveConfirmation = true;
      next(false);
    } else {
      this.$store.dispatch("clearNewConfigValues");
      next();
    }
  },
};
</script>
  
<style lang="scss" scoped>
main {
  height: calc(100vh - $header-height);
  .wrapper {
    height: 100%;
    .name-unset {
      &::v-deep {
        .title-row h5 {
          color: $qvo-color-grey-500;
        }
      }
    }
  }
}
</style>